import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { createElement } from 'react';

var _excluded = ["condition", "wrapper", "otherwise", "children"];
/**
 * ConditionalWrapper
 *
 * A Higher order component to encapsulate the wrapping of modules based on a condition
 *
 * @example
 *  <ConditionalWrapper
 *    condition={shouldWrapWithcontainer === true}
 *    wrapper={Container}
 *    otherwise={Fragment} />
 *
 * @param {Object} props - The component properies.
 * @param {Boolean} props.condition - The condition to render the component based on
 * @param {any} props.wrapper - The wrapper component
 * @param {any} [props.otherwise] - The alternative wrapper, defaults to just children
 *
 * @returns {*} MaybeWrappedComponent
 */
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    otherwise = _ref.otherwise,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return condition ? /*#__PURE__*/createElement(wrapper, rest, children) : otherwise ? /*#__PURE__*/createElement(otherwise, rest, children) : children;
};

export { ConditionalWrapper };
